import React, { useEffect } from "react";//
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as eventActions from "../modules/Settings/_redux/events/eventsActions";
import * as professionalActions from "../modules/Settings/_redux/professionals/professionalsActions";

import { Alert } from "react-bootstrap";
import {TilesWidget11 } from "../../_yp_db/_partials/widgets";

export function DashboardPage() {
    
    const { user_id,first_name,totalEvents,totalProfessionals } = useSelector( //totalQuestionAnswers
        (state) => ({
            user_id: state.auth.user.id || "",
            first_name: state.auth.user.first_name || "",
            totalEvents : state.events.totalCount,
            totalProfessionals : state.professionals.totalCount,

        }),
        shallowEqual
    );

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(eventActions.fetchEvents());
        dispatch(professionalActions.fetchProfessionals());
        // eslint-disable-next-line 
    }, [dispatch, user_id]);

    //function to display a HTML grid of 3 by two

    const grid = (widget1, widget2) => {
        return (
            <div className="col-lg-12 row">
                <div className="col-xl-6">
                    {widget1}
                </div>
                <div className="col-xl-6">
                    {widget2}
                </div>
            </div>
        )
    }


    return (<>
        <div className="row">
            <div className="col-xl-12">
                <div className="card card-custom gutter-b card-stretch">
                    <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                            <h2>Young Professionals Admin</h2>
                            <Alert variant="primary"> Welcome {first_name}!</Alert>
                        </div>
                    </div>
                </div>
            </div>
    
            {grid(
                <TilesWidget11 svgIcon="media/svg/icons/Communication/Group-chat.svg" className="card-stretch gutter-b" baseColor="primary" value={totalEvents} label="Total Events" />,
                <TilesWidget11 svgIcon="media/svg/icons/Communication/Shield-user.svg" className="card-stretch gutter-b" baseColor="primary" value={totalProfessionals} label="Total Young Professionals" />
            )}
        </div>
    </>);
}
